import React from 'react';
import { Bell, CheckSquare, X } from '@phosphor-icons/react';

const NOTIF_TYPE_STYLES = {
  success: { color: '#2E7D32', bg: '#E8F5E9' },
  error: { color: '#C62828', bg: '#FFEBEE' },
  info: { color: '#1565C0', bg: '#E3F2FD' },
  chat: { color: '#6A1B9A', bg: '#F3E5F5' }
};

const formatTimeAgo = (dateStr) => {
  const now = new Date();
  const d = new Date(dateStr);
  const diffMs = now - d;
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "a l'instant";
  if (mins < 60) return `il y a ${mins}min`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `il y a ${hours}h`;
  return `il y a ${Math.floor(hours / 24)}j`;
};

export const NotificationPanel = ({
  notifications, unreadCount, primaryColor, t,
  onMarkAllRead, onClose, onNotifClick,
  style
}) => (
  <div data-testid="notification-panel" style={{
    backgroundColor: 'var(--background, white)', borderRadius: '8px', boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
    zIndex: 9999, maxHeight: '480px', display: 'flex', flexDirection: 'column', border: '1px solid var(--border, #E2E2E6)',
    ...style
  }}>
    <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--border, #E2E2E6)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span style={{ fontWeight: '700', fontSize: '0.9rem' }}>{t('common.notifications')}</span>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {unreadCount > 0 && (
          <button data-testid="mark-all-read-btn" onClick={onMarkAllRead}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: primaryColor, fontSize: '0.75rem', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <CheckSquare size={14} /> {t('common.mark_all_read')}
          </button>
        )}
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={18} color="#5E5F66" /></button>
      </div>
    </div>
    <div style={{ overflowY: 'auto', flex: 1 }}>
      {notifications.length === 0 ? (
        <div style={{ padding: '40px 20px', textAlign: 'center', color: '#5E5F66' }}>
          <Bell size={32} style={{ opacity: 0.4, marginBottom: '8px' }} />
          <p style={{ fontSize: '0.85rem' }}>{t('common.no_notifications')}</p>
        </div>
      ) : notifications.map(notif => {
        const typeStyle = NOTIF_TYPE_STYLES[notif.type] || NOTIF_TYPE_STYLES.info;
        return (
          <div key={notif.id} data-testid={`notification-item-${notif.id}`} onClick={() => onNotifClick(notif)}
            style={{ padding: '12px 16px', cursor: 'pointer', borderBottom: '1px solid #F4F5F7', backgroundColor: notif.read ? 'var(--background, white)' : '#FAFBFF', transition: 'background-color 0.2s', display: 'flex', gap: '10px', alignItems: 'flex-start' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F4F5F7'}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = notif.read ? 'var(--background, white)' : '#FAFBFF'; }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: notif.read ? 'transparent' : typeStyle.color, marginTop: '6px', flexShrink: 0 }} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: notif.read ? '400' : '600', fontSize: '0.8rem', color: 'var(--text-primary, #0A0B10)', marginBottom: '2px' }}>{notif.title}</div>
              <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary, #5E5F66)', lineHeight: '1.3', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{notif.message}</div>
              <div style={{ fontSize: '0.65rem', color: '#9E9EA7', marginTop: '4px' }}>{formatTimeAgo(notif.created_at)}</div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);
